import { arrayOf, bool, oneOf, shape, string } from 'prop-types'
import { PasswordStatus } from '../../models/users/password-status-enum'
import { CurrentUserStates } from '../../models/current-user/current-user-states-enum'
import { idPropType } from '../common/id-prop-type'
import { linkedUserPropType } from './linked-user-prop-type'
import { multiAccountPropType } from './multi-account-prop-type'

/**
 * @typedef {Object} currentUser
 * @property {string} [displayUsername] - A human readable account and username combination for AD-managed users in
 *                                        exchange for cryptic UUID from AD (e.g. 'sdev02 - robert.kuehn@webfleet.com'
 *                                        instead of 'sdev02 — Hb6wqUffRCaz1BJoKeZnEzRxmpUCL59tPBhf9yoQiiU')
 * @property {string} [email] - The current users email
 * @property {string} [passwordStatus] - The current users password status
 * @property {string} [preferredUsername] - The current users username
 * @property {string} [sub] - Combination or username and account (e.g. 'svogt@sdev04')
 * @property {string} [userId] - The current webfleet user id
 * @property {string} [keyCloakId] - The current keycloak user id
 * @property {string} [accountId] - The current users account id from UMS or Auth-Server
 * @property {string} [state] - The current users account state
 * @property {array} [usersLinkedToExternalUser] - All other logins / accounts the user has access to (Auth-Server)
 * @property {array} [linkedWebfleetUsers] - All other logins / accounts the user has access to (UMS)
 * @property {boolean} isUserFromUMS - defines if user is logged in from UMS
 * @property {boolean} isUserFromAuthServer - defines if user is logged in from Auth-Server / Azure
 */
export const currentUserPropType = shape({
    accountId: idPropType,
    displayUserName: string,
    email: string,
    isUserFromAuthServer: bool,
    isUserFromUMS: bool,
    keyCloakId: idPropType,
    linkedWebfleetUsers: arrayOf(linkedUserPropType),
    passwordStatus: oneOf(Object.values(PasswordStatus)),
    preferredUsername: string,
    state: oneOf(Object.values(CurrentUserStates)),
    sub: string,
    userId: idPropType,
    usersLinkedToExternalUser: arrayOf(multiAccountPropType)
})
